/**
 * TabBar — EasyAdmin-style multi-tab navigation.
 *
 * Renders one chip per open tab. Clicking a chip activates it (and routes);
 * clicking the × closes it. The Dashboard tab is pinned (closable:false).
 * Actual KeepAlive of page state is handled in MainLayout via display:none.
 */
import { CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTabsStore } from '../store/tabs';

export function TabBar() {
  const tabs = useTabsStore((s) => s.tabs);
  const activeKey = useTabsStore((s) => s.activeKey);
  const activate = useTabsStore((s) => s.activate);
  const close = useTabsStore((s) => s.close);
  const navigate = useNavigate();

  if (tabs.length === 0) return null;

  return (
    <div className="uo-tab-bar">
      {tabs.map((t) => (
        <div
          key={t.key}
          className={`uo-tab ${t.key === activeKey ? 'active' : ''}`}
          onClick={() => {
            activate(t.key);
            navigate(t.path);
          }}
        >
          <span>{t.label}</span>
          {t.closable && (
            <CloseOutlined
              className="uo-close"
              style={{ fontSize: 10 }}
              onClick={(e) => {
                e.stopPropagation();
                close(t.key);
                const remaining = useTabsStore.getState().tabs;
                const next = remaining[remaining.length - 1];
                if (next) navigate(next.path);
                else navigate('/platform/dashboard');
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
